<template>
  <div class="showOnlyPrint">
    <div style="display: flex" class="encabezado">
      <div style="float: left; text-align: center; width: 50%">
        <div style="width: 350px">
          <i>SERVICIO LOCAL DE ACUEDUCTOS Y ALCANTARILLADO</i><br>
          <i>SeLA - Oruro</i>
        </div>
      </div>
      <div style="text-align: right; float: right; width: 50%">
        FECHA Y HORA: {{ fecha }}<br>
      </div>
    </div>

    <h3 class="print_center" v-html="title"></h3>
    <p v-if="subtitle" class="subtitulo print_center" style="margin-top: -20px;" v-html="subtitle"></p>
  </div>
</template>

<script lang="ts">
import {Component, Vue, Prop} from "vue-property-decorator";
import {globalStore} from "@/store/globalStore";
import {UserAuth} from "@/models/UserAuth";
import {GlobalService} from "@/services/GlobalService";

@Component({
  name: 'HeadReport'
})

export default class HeadReport extends Vue {
  globalStore = globalStore();
  globalServide = GlobalService.getInstance();

  @Prop() title!: string;
  @Prop() subtitle!: string;

  get fecha () {
    return this.globalStore.fecha;
  }

  get usuario(): any {
    return new UserAuth();
  }

  mounted () {
    this.getFecha();
  }

  getFecha() {
    this.globalServide.getFecha();
  }
}
</script>

<style scoped>
.showOnlyPrint{
  display: none;
}
</style>